import React from 'react';
import SyntaxHighlighter from "react-syntax-highlighter";
import {docco} from "react-syntax-highlighter/dist/cjs/styles/hljs";
import {Typography} from "@wds/typography";
import {Box} from "@wds/box";
const {yamlFile} = require("./examplesCommon");
const {jsLibrary, jsExampleProgram} = require("./javascriptExample");

const CodeLibraries = (props) => {
	const {theme} = props;

	return (
		<Box>
			<Typography variant="sectionTitle" component="h1" weight="medium">Code Libraries</Typography>
				<Box mb={5}>
					<Typography component="p">
						These samples are simple libraries for accessing the Connect API. While not production
						ready code (hello error checking), it should give you a starting point to see how to
						work with the API.
					</Typography>
				</Box>
			<Typography variant="sectionTitleSm">Configuration File</Typography>
			<Typography component="p">
				This YAML file is used by both examples. It holds the configuration for the code
				libraries. The initial values should be copied from your integration settings.
			</Typography>
			<Box my={5} ml={5} mr={10} pr={10}>
				<SyntaxHighlighter language="yaml" style={theme}>{yamlFile}</SyntaxHighlighter>
			</Box>
			{/*We haven't provided a sample python library, so commenting this out for now.*/}
			{/*<Box>*/}
			{/*	<Typography variant="sectionTitle" component="h3" weight="medium">Python</Typography>*/}
			{/*</Box>*/}
			<Box>
				<Typography variant="sectionTitleSm">JavaScript</Typography>
				<Box my={2}>
					<Typography component="p" weight="medium">
						connect.js<Typography component="span">: This simple library handles access token expiry. The
						configuration for the library is stored in a YAML file.</Typography>
					</Typography>
					<Box my={5} ml={5} mr={10} pr={10}>
						<SyntaxHighlighter language="javascript" style={theme}>{jsLibrary}</SyntaxHighlighter>
					</Box>
				</Box>
				<Box>
					<Typography component="p" weight="medium">
						applications.js<Typography component="span">: A sample program to retrieve applications.</Typography>
					</Typography>
					<Box my={5} ml={5} mr={10} pr={10}>
						<SyntaxHighlighter language="javascript" style={theme}>{jsExampleProgram}</SyntaxHighlighter>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

module.exports = CodeLibraries;
